var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.333,
    height: 25.666,
    viewBox: "0 0 29.333 25.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-gift",
    "data-name": "Icon awesome-gift",
    d: "M1.833,26.083a1.831,1.831,0,0,0,1.833,1.833h9.166V18.75h-11ZM16.5,27.916h9.166A1.831,1.831,0,0,0,27.5,26.083V18.75h-11Zm11-18.333H25.088a5,5,0,0,0,.579-2.292A5.049,5.049,0,0,0,20.625,2.25c-2.383,0-3.924,1.22-5.9,3.913C12.747,3.47,11.206,2.25,8.823,2.25A5.049,5.049,0,0,0,3.781,7.292,4.925,4.925,0,0,0,4.36,9.583H1.833A1.831,1.831,0,0,0,0,11.416V16a.919.919,0,0,0,.917.917h27.5A.919.919,0,0,0,29.333,16V11.416A1.831,1.831,0,0,0,27.5,9.583Zm-18.682,0A2.292,2.292,0,1,1,8.817,5c1.14,0,1.982.189,4.933,4.583H8.817Zm11.808,0H15.692C18.637,5.2,19.456,5,20.625,5a2.292,2.292,0,1,1,0,4.583Z",
    transform: "translate(0 -2.25)",
    fill: "#e8339e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7ecca5be5c9b24264b198af829248f3b.svg";
export { ForwardRef as ReactComponent };